import { ContentFilter, StarredItems } from 'types';

import { get, post } from './axios';

const URL = {
  getStates: 'get-states',
  getLocations: 'get-locations',
  getLocationsForService: 'get-svc-locations',
  getFavoriteServices: 'get-starred-items',
  setFavoriteServices: 'set-star-item',
  deleteFavoriteServices: 'del-star-item',
  getGoogleMapsCoordinates: '/api/get-google-coordinates'
};

const locationsApi = {
  getStates: () => get(URL.getStates),
  getLocations: (filter: ContentFilter) =>
    get(URL.getLocations, { content_filter: filter }),
  getLocationsForService: (serviceId: number) =>
    get(URL.getLocationsForService, { svcid: serviceId }),
  getStarredItems: (itemType: keyof typeof StarredItems) =>
    get(URL.getFavoriteServices, { item_type: StarredItems[itemType] }),
  setStarredItem: (itemType: keyof typeof StarredItems, item_num: number) =>
    get(URL.setFavoriteServices, {
      item_type: StarredItems[itemType],
      item_num
    }),
  deleteFavoriteServices: (
    itemType: keyof typeof StarredItems,
    item_num: number
  ) =>
    get(URL.deleteFavoriteServices, {
      item_type: StarredItems[itemType],
      item_num
    }),
  getGoogleMapsCoordinates: (url: string) =>
    post(URL.getGoogleMapsCoordinates, { url })
};

export default locationsApi;
